<template>
  <div class="g-page">
    <div class="content-container">

      <!-- HEADER -->
      <div class="header-row">
        <h2 class="page-title">{{ $t($route.name) }}</h2>
        <div class="header-actions">

          <!-- Qidiruv -->
          <div class="search-wrapper">
            <b-icon icon="search" class="search-icon"></b-icon>
            <input id="filter-input" v-model="filter" type="search" @input="Data(parent)"
              :placeholder="$t('Qidiruv...')" class="modern-search">
          </div>

          <!-- Excel -->
          <button class="tool-btn" @click="Xlsx()" title="Excel">
            <b-icon icon="download"></b-icon> Excel
          </button>

          <!-- Qo'shish -->
          <button class="add-btn" @click="Href('/malumot/product/create')" v-if="rule.change==true">
            <b-icon icon="plus-circle-fill"></b-icon> {{ $t("Qo'shish") }}<sup>ins</sup>
          </button>

          <!-- Fayl yuklash -->
          <button class="tool-btn" v-b-modal.modal-upload type="button" title="Fayl yuklash">
            <b-icon icon="file-earmark-arrow-up"></b-icon>
          </button>

          <!-- Shtrix kod -->
          <button class="tool-btn" @click="Href('/product/barcode','blank')" v-if="rule.change==true" title="Shtrix kod">
            <b-icon icon="upc-scan"></b-icon>
          </button>

          <!-- Yangilash -->
          <button class="refresh-btn" @click="Data(parent)" title="Yangilash">
            <b-icon icon="arrow-repeat"></b-icon>
          </button>

          <top></top>
        </div>
      </div>

      <!-- JADVAL -->
      <div class="table-card">
        <div class="table-wrapper">
          <table class="custom-table">
            <thead>
              <tr>
                <th style="width: 60px"></th>
                <th style="width: 30%">{{ $t("Номи") }}</th>
                <th class="th-right">{{ $t("Қолдиқ") }}</th>
                <th class="th-right">{{ $t("Тан нарх") }}</th>
                <th class="th-right">{{ $t("Чакана") }} {{ $t("Нарх") }}</th>
                <th class="th-right">{{ $t("Улгуржи") }} {{ $t("Нарх") }}</th>
                <th class="th-right">{{ $t("Чакана") }} {{ $t("Нарх") }}$</th>
                <th class="th-right">{{ $t("Улгуржи") }} {{ $t("Нарх") }}$</th>
                <th style="width: 120px; text-align: center;">{{ $t("AMALLAR") }}</th>
              </tr>
            </thead>
            <tbody>
              <!-- Orqaga qaytish -->
              <tr class="navigation-row" @dblclick="Data(parent)">
                <td>
                  <b-icon icon="arrow-left-circle-fill" variant="secondary"></b-icon>
                </td>
                <td style="width: 30%;">
                  <button type="button" class="go-back-btn">..</button>
                </td>
                <td colspan="7"></td>
              </tr>

              <!-- Ma'lumotlar -->
              <tr v-for="(item, index) in items" :key="index"
                :class="{ 'folder-row': item.is_folder }">
                <td @dblclick="Select(item)" style="cursor: pointer;">
                  <span v-if="item.is_folder">
                    <b-icon icon="folder-fill" variant="warning" font-scale="1.1"></b-icon>
                  </span>
                  <span class="id-text">{{ item.id }}</span>
                </td>
                <td style="width: 30%; cursor: pointer;" @dblclick="Select(item)">
                  <button type="button" :class="['item-name', { 'folder-name': item.is_folder }]">
                    <span v-if="item.parent_id > 0" style="padding:0 15px;"></span>
                    {{ item.extra_name }}
                  </button>
                </td>
                <td class="td-right td-balance" @dblclick="Select(item)" style="cursor: pointer;">
                  {{ item.balance | numFormat }}
                </td>
                <td class="td-right" @dblclick="Select(item)" style="cursor: pointer;">
                  <span v-if="item.price_register">
                    {{ item.price_register.body_price | numFormat }}
                  </span>
                </td>
                <td class="td-right" @dblclick="Select(item)" style="cursor: pointer;">
                  <span v-if="item.price_register">
                    {{ item.price_register.chakana_price | numFormat }}
                  </span>
                </td>
                <td class="td-right" @dblclick="Select(item)" style="cursor: pointer;">
                  <span v-if="item.price_register">
                    {{ item.price_register.optom_price | numFormat }}
                  </span>
                </td>
                <td class="td-right" @dblclick="Select(item)" style="cursor: pointer;">
                  <span v-if="item.price_register">
                    {{ item.price_register.chakana_dollar_price | numFormat }}
                  </span>
                </td>
                <td class="td-right" @dblclick="Select(item)" style="cursor: pointer;">
                  <span v-if="item.price_register">
                    {{ item.price_register.optom_dollar_price | numFormat }}
                  </span>
                </td>
                <td>
                  <div class="actions">
                    <router-link :to="{ name: 'Продукт ўзгартириш', params: { id: item.id } }">
                      <button type="button" class="icon-btn edit">
                        <b-icon icon="pencil-square"></b-icon>
                      </button>
                    </router-link>
                    <button type="button" class="icon-btn del" @click="Trash(item.id)">
                      <b-icon icon="trash"></b-icon>
                    </button>
                  </div>
                </td>
              </tr>

              <!-- Ko'proq yuklash -->
              <tr v-if="add==true">
                <td colspan="9" class="load-more-row">
                  <button class="load-more-btn" @click="Add()">{{ $t('Eshyo') }}</button>
                </td>
              </tr>

              <!-- Bo'sh holat -->
              <tr v-if="items.length === 0">
                <td colspan="9" class="empty-row">{{ $t("Ma'lumot topilmadi") }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- FOOTER -->
        <div class="table-footer">
          <div class="info">
            Jami: <b>{{ items.length }}</b> ta mahsulot
          </div>
        </div>
      </div>
    </div>

    <!-- SKLAD COMPONENT -->
    <b-container fluid>
      <sklad :datas="datas"></sklad>

      <!-- FAYL YUKLASH MODAL -->
      <b-modal id="modal-upload" title="" size="xl" hide-footer @shown="Shovedform">
        <form>
          <div class="row">
            <div class="col-md-6">
              <label for="">Склад</label>
            </div>
            <div class="col-md-6">
              <v-select :clearable="false" class="md-input" :options="skladlist" v-model="datas.sklad_id"
                :reduce="name => name.id" label="name">
                <template #search="{attributes, events}">
                  <input class="vs__search" v-bind="attributes" v-on="events" />
                  <button type="button" class="modallist" v-b-modal.modal-skladlist>
                    <b-icon icon="three-dots"></b-icon>
                  </button>
                </template>
                <template v-slot:no-options="{ search, searching }">
                  <template v-if="searching">
                    <em><b>{{ search }}</b></em>
                    {{ $t("бўйича маьлумот йўқ") }}
                    <button type="button" @click="unit.name = search" v-b-modal.modal-unit class="pluss">
                      +
                    </button>
                    <b>insert</b>
                  </template>
                  <em style="opacity: 0.5;" v-else>{{ $t("Маьлумот йўқ") }}</em>
                </template>
              </v-select>
            </div>
            <div class="col-md-6">
              <label for="">{{ $t('Тўлов тури') }}</label>
            </div>
            <div class="col-md-6">
              <v-select :clearable="false" class="form-control-sm required md-input" :options="paytypelist"
                v-model="datas.pay_type_id" :reduce="name => name.id" label="name">
              </v-select>
            </div>
            <div class="col-md-6">
              <label for="">Курс</label>
            </div>
            <div class="col-md-6">
              <input type="number" v-model="datas.dollar_rate" class="form-control">
            </div>
          </div>
          <input type="file" id="file" ref="file" v-on:change="handleFileUpload()" />
          <button type="button" class="btn btn-primary" @click="Yuklash()">
            {{ $t("Сақлаш") }}
          </button>
        </form>
      </b-modal>
    </b-container>
  </div>
</template>

<script>
  import Top from "../../Layout/Top.vue";
  import VueAutoVirtualScrollList from "vue-auto-virtual-scroll-list";
  import $ from "jquery";
  import { print } from "../../../components/mixins/print.js";
  import filterFunction from "../../../utils/filterFunction";
  import { Sklad } from "@/pages";
  export default {
    components: { Sklad, Top, VueAutoVirtualScrollList },
    mixins: [print],
    data() {
      return {
        file: "",
        send:false,
        add:true,
        limit: 100,
        page:1,
        parent: 0,
        datas: {
          file: "",
          sklad_id: parseInt(localStorage.getItem("sklad_id")),
          pay_type_id:1,
          dollar_rate:1,
        },
        paytypelist:[],
        items: [],
        sklad: "",
        skladlist: [],
       totalRows: 1,
        currentPage: 1,
        filter: "",
      };
    },
    computed: {
      sortOptions() {
        // Create an options list from our fields
        return this.fields
          .filter(f => f.sortable)
          .map(f => {
            return { text: f.label, value: f.key };
          });
      }
    },
    mounted: function() {
            this.Data(this.$store.state.parent_id);
    },
    created: function () {
    this.parent=this.$store.state.parent_id;
      let self = this;
      self.$root.$on("skladone", function (getdata) {
        self.sklad = getdata;
      });
      self.$root.$on("skladall", function (getdata) {
        self.skladlist = getdata;
      });
      axios.get("api/v1/pay-type").then(function(response) {
        self.paytypelist = response.data;
      });
      axios
        .get("api/v1/dollar-exchange-rate/last")
        .then(function(response) {
            self.datas.dollar_rate=response.data.rate;
        });
      // self.Interval();
    },
    methods: {
      filterFunction,
      Dowloadfile(file){
        let self=this;
        axios({
                    url: 'api/v1/uploads/'+file, // File URL Goes Here
                    method: 'GET',
                    responseType: 'blob',
                }).then((res) => {
                     var FILE = window.URL.createObjectURL(new Blob([res.data]));
                     var docUrl = document.createElement('a');
                     docUrl.href = FILE;
                     docUrl.setAttribute('download', file);
                     document.body.appendChild(docUrl);
                     docUrl.click();
                });

      },
      Xlsx(){
        let self=this;
        axios({
          method: "post",
          url: "api/v1/download/product",
          data: {
            sklad_id: parseInt(localStorage.getItem("sklad_id"))
          }
        })
          .then(function (response) {
          self.Dowloadfile(response.data);
          });
      },
      Add(){
        let self = this;
        self.page+=1;
        if (localStorage.getItem("sklad_id") > 0) {
        var datetime = null;
        var keyword = "";
        if (self.filter.length > 2) {
          keyword = self.filter;
        }
        axios({
          method: "post",
          url: "api/v1/product/all-price-balance/" + self.items[0].parent_id,
          data: {
            sklad_id: localStorage.getItem("sklad_id"),
            datetime: datetime,
            keyword: keyword,
            page:self.page,
            limit:self.limit
          }
        })
          .then(function (response) {
            var b = self.items.concat(response.data);
            self.items = b
            if(response.data.length==self.limit){
            }else{
              self.add=false;
             }

          });
        }
      },
      Select(item) {
        this.$store.state.parent_id=item.parent_id;
      if(item.is_folder==false){
        this.$router.push({ path: '/malumot/product/update/' + item.id });
      }else{
        this.parent=item.parent_id;
      this.Data(item.id);
      setTimeout(() => {
        $('.atable:eq(0)').focus()
      }, 100);
      }
    } ,
      Update(record, index) {
        if (this.rule.open == true) {
          this.$router.push({ path: '/malumot/product/update/' + record.id });
        }
      },
      handleFileUpload() {
        this.file = this.$refs.file.files;
        this.datas.file = URL.createObjectURL(this.$refs.file.files[0]);
      },
      Bazayuklash() {
        axios({
          method: "get",
          url: "api/v1/download/dump"
        }).then(function (response) { });
      },
      Yuklash() {
        let self = this;
        if(self.send==false){
          self.send=true;
          let formData = new FormData();
        let file = self.file[0];
        formData.append("file_name", file);
        formData.append("sklad_id", this.datas.sklad_id);
        formData.append("pay_type_id", this.datas.pay_type_id);
        formData.append("dollar_rate", this.datas.dollar_rate);
        formData.append("user_id", localStorage.getItem("user_id"));
        axios({
          method: "post",
          url: "api/v1/upload/product",
          data: formData
        }).then(function (response) {
          self.datas.file="";
          self.file="";
          self.send=false;
          self.$bvModal.hide("modal-upload");
          self.Data(self.parent);
        }).catch(function(error){
          self.send=false;
        });
        }else{
          console.log('not');
        }
      },
      Data(parent) {
        let self = this;
        if (localStorage.getItem("sklad_id") > 0) {
        var datetime = null;
        var keyword = "";
        if (self.filter.length > 2) {
          keyword = self.filter;
        }
        axios({
          method: "post",
          url: "api/v1/product/all-price-balance/" + parent,
          data: {
            sklad_id: localStorage.getItem("sklad_id"),
            datetime: datetime,
            keyword: keyword,
            page:self.page,
            limit:self.limit
          }
        })
          .then(function (response) {
            self.items = response.data;
            self.page=1;
            if (response.data.length>0 && response.data[0].parent_id > 0) {
              axios
                .get("api/v1/product/id/" + response.data[0].parent_id)
                .then(function (response) {
                  self.parent = response.data.parent_id;
                });
            }
          });
        }else {
        self.productlist = [];
        }
      },
      Interval() {
        window.setInterval(() => {
          this.Data(self.parent);
        }, 60000);
      },
      Trash(id) {
        let self = this;
        self.$prompt(self.$t("Паролни киритинг")).then(text => {
          if (text == self.update_password) {
            axios({
              method: "delete",
              url: "api/v1/product/id/" + id
            }).then(function (response) {
              self.Data(self.parent);
              self.Cacheclear();
            });
          } else {
            self.$store.state.errors = self.$t("Парол хато");
          }
        })
          .catch(function () { });
      },
      Cacheclear() {
      let self = this;
      axios({
        method: "post",
        url: "api/v1/cache-clear/all-price-balance",
        data: {
          sklad_id: localStorage.getItem("sklad_id"),
          datetime: localStorage.getItem("created_at")
        }
      }).then(function(response) {
        self.Data(self.parent);
      });
    },
      Shovedform() {
        this.$refs.file.focus();
      }
    }
  };
</script>

<style scoped>
/* SAHIFA ASOSI */
.g-page {
  padding: 20px;
  background: #f8fafc;
  height: 100vh;
  display: flex;
  flex-direction: column;
}

.content-container {
  max-width: 1400px;
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  height: 100%;
}

/* HEADER */
.header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.page-title {
  color: #a142f4;
  font-weight: 800;
  font-size: 26px;
  margin: 0;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

/* SEARCH */
.search-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.search-icon {
  position: absolute;
  left: 12px;
  color: #94a3b8;
}

.modern-search {
  background: white;
  border: 1px solid #e2e8f0;
  padding: 8px 15px 8px 35px;
  border-radius: 12px;
  width: 220px;
  outline: none;
  transition: 0.3s;
}

.modern-search:focus {
  border-color: #a142f4;
  box-shadow: 0 0 0 4px rgba(161, 66, 244, 0.1);
}

/* TUGMALAR */
.add-btn {
  background: linear-gradient(135deg, #a142f4 0%, #8b2cf5 100%);
  color: white;
  border: none;
  height: 40px;
  padding: 0 20px;
  border-radius: 12px;
  font-weight: 700;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  box-shadow: 0 4px 15px rgba(161, 66, 244, 0.3);
  transition: 0.2s;
}

.add-btn:hover {
  transform: translateY(-1px);
}

.add-btn sup {
  font-weight: 400;
  opacity: 0.7;
}

.tool-btn {
  background: white;
  border: 1px solid #e2e8f0;
  color: #64748b;
  height: 40px;
  padding: 0 14px;
  border-radius: 12px;
  font-weight: 600;
  font-size: 13px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: 0.2s;
}

.tool-btn:hover {
  border-color: #a142f4;
  color: #a142f4;
}

.refresh-btn {
  background: white;
  border: 1px solid #e2e8f0;
  color: #64748b;
  width: 40px;
  height: 40px;
  border-radius: 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.2s;
}

.refresh-btn:hover {
  border-color: #a142f4;
  color: #a142f4;
}

/* JADVAL KARTASI */
.table-card {
  background: white;
  border-radius: 24px;
  padding: 10px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.03);
  border: 1px solid #f1f5f9;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.table-wrapper {
  overflow-y: auto;
  flex-grow: 1;
}

.custom-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
}

.custom-table thead {
  position: sticky;
  top: 0;
  z-index: 5;
}

.custom-table th {
  background: white;
  padding: 16px 15px;
  color: #94a3b8;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 1px solid #f1f5f9;
}

.th-right {
  text-align: right;
}

.custom-table td {
  padding: 12px 15px;
  border-bottom: 1px solid #f8fafc;
  vertical-align: middle;
  font-size: 14px;
  color: #334155;
}

.td-right {
  text-align: right;
  font-variant-numeric: tabular-nums;
}

.td-balance {
  font-weight: 700;
  color: #2c3e50;
}

.custom-table tbody tr:hover:not(.navigation-row) {
  background: #faf8ff;
}

/* NAVIGATION */
.navigation-row {
  cursor: pointer;
}

.navigation-row:hover td {
  color: #a142f4;
  background: #faf8ff;
}

.go-back-btn {
  background: none;
  border: none;
  font-weight: 700;
  color: #94a3b8;
  font-size: 16px;
  cursor: pointer;
}

/* FOLDER */
.folder-row {
  background-color: #fffbeb;
}

.folder-row:hover {
  background-color: #fef3c7 !important;
}

.id-text {
  float: right;
  font-size: 12px;
  color: #94a3b8;
  font-weight: 600;
}

.item-name {
  background: none;
  border: none;
  font-weight: 600;
  color: #334155;
  font-size: 14px;
  cursor: pointer;
  text-align: left;
  padding: 0;
}

.folder-name {
  color: #d97706;
  font-weight: 700;
}

/* AMALLAR */
.actions {
  display: flex;
  gap: 8px;
  justify-content: center;
}

.icon-btn {
  width: 34px;
  height: 34px;
  border-radius: 10px;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.2s;
  cursor: pointer;
}

.edit {
  background: #eff6ff;
  color: #2563eb;
}

.edit:hover {
  background: #2563eb;
  color: white;
  transform: scale(1.1);
}

.del {
  background: #fff1f2;
  color: #e11d48;
}

.del:hover {
  background: #e11d48;
  color: white;
  transform: scale(1.1);
}

/* KO'PROQ YUKLASH */
.load-more-row {
  text-align: center;
  padding: 15px !important;
}

.load-more-btn {
  background: #f0e6ff;
  color: #a142f4;
  border: none;
  padding: 8px 30px;
  border-radius: 10px;
  font-weight: 700;
  font-size: 14px;
  cursor: pointer;
  transition: 0.2s;
}

.load-more-btn:hover {
  background: #a142f4;
  color: white;
}

/* FOOTER */
.table-footer {
  padding: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid #f1f5f9;
  color: #64748b;
  font-size: 13px;
}

.empty-row {
  text-align: center;
  padding: 60px !important;
  color: #94a3b8;
  font-style: italic;
}

@media (max-width: 768px) {
  .g-page {
    padding: 10px;
  }

  .header-row {
    flex-direction: column;
    gap: 12px;
    align-items: flex-start;
  }

  .header-actions {
    flex-wrap: wrap;
  }

  .modern-search {
    width: 100%;
  }
}
</style>
